import axiosInstance from '@/api/axiosInstance';
import { DeleteSkillResponse } from './types';

/**
 * Delete a skill
 * DELETE /api/learning-center/skills/:id
 * Requires ROLE_LEARNING_ADMIN or ROLE_SUPER_ADMIN
 */
export const deleteSkill = async (id: number): Promise<DeleteSkillResponse> => {
  try {
    const response = await axiosInstance.delete<DeleteSkillResponse>(
      `/api/learning-center/skills/${id}`
    );
    return response.data;
  } catch (error) {
    console.error(`Error deleting skill ${id}:`, error);
    throw error;
  }
};
